// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("iconfont.woff2?t=1698113050387", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("iconfont.woff?t=1698113050387", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("iconfont.ttf?t=1698113050387", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "iconfont"; /* Project id 4284375 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-Twitter2:before {
  content: "\\e696";
}

.icon-a-zhishijiantou_huaban1fuben17:before {
  content: "\\e695";
}

.icon-weibo:before {
  content: "\\e693";
}

.icon-weixin:before {
  content: "\\e694";
}

.icon-jianyi:before {
  content: "\\e68f";
}

.icon-youxiang:before {
  content: "\\e690";
}

.icon-mingzi:before {
  content: "\\e691";
}

.icon-a-fasong_huaban1fuben14:before {
  content: "\\e692";
}

.icon-a-xiazai_huaban1:before {
  content: "\\e68e";
}

.icon-shang:before {
  content: "\\e68d";
}

.icon-zanting:before {
  content: "\\e686";
}

.icon-xia:before {
  content: "\\e685";
}

.icon-weizhi:before {
  content: "\\e687";
}

.icon-jingyin:before {
  content: "\\e688";
}

.icon-zuo:before {
  content: "\\e689";
}

.icon-bofang:before {
  content: "\\e68a";
}

.icon-dakaiyinliang:before {
  content: "\\e68b";
}

.icon-you:before {
  content: "\\e68c";
}

`, "",{"version":3,"sources":["webpack://./src/assets/font/iconfont.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,uBAAuB;EAChD;;iEAE2D;AAC7D;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: \"iconfont\"; /* Project id 4284375 */\n  src: url('iconfont.woff2?t=1698113050387') format('woff2'),\n       url('iconfont.woff?t=1698113050387') format('woff'),\n       url('iconfont.ttf?t=1698113050387') format('truetype');\n}\n\n.iconfont {\n  font-family: \"iconfont\" !important;\n  font-size: 16px;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-Twitter2:before {\n  content: \"\\e696\";\n}\n\n.icon-a-zhishijiantou_huaban1fuben17:before {\n  content: \"\\e695\";\n}\n\n.icon-weibo:before {\n  content: \"\\e693\";\n}\n\n.icon-weixin:before {\n  content: \"\\e694\";\n}\n\n.icon-jianyi:before {\n  content: \"\\e68f\";\n}\n\n.icon-youxiang:before {\n  content: \"\\e690\";\n}\n\n.icon-mingzi:before {\n  content: \"\\e691\";\n}\n\n.icon-a-fasong_huaban1fuben14:before {\n  content: \"\\e692\";\n}\n\n.icon-a-xiazai_huaban1:before {\n  content: \"\\e68e\";\n}\n\n.icon-shang:before {\n  content: \"\\e68d\";\n}\n\n.icon-zanting:before {\n  content: \"\\e686\";\n}\n\n.icon-xia:before {\n  content: \"\\e685\";\n}\n\n.icon-weizhi:before {\n  content: \"\\e687\";\n}\n\n.icon-jingyin:before {\n  content: \"\\e688\";\n}\n\n.icon-zuo:before {\n  content: \"\\e689\";\n}\n\n.icon-bofang:before {\n  content: \"\\e68a\";\n}\n\n.icon-dakaiyinliang:before {\n  content: \"\\e68b\";\n}\n\n.icon-you:before {\n  content: \"\\e68c\";\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
